import { Component, OnInit } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { DataService } from './../../../services/data/data.service';
import { firstValueFrom, forkJoin, Subscription } from 'rxjs';
import { FuncionesMes, formatear, periodosOperativo} from './../../funciones/funcionesGenerales';
import { IMG } from '../../../services/imagen/png';
import { ExcelService } from '../../../services/excel/excel.service';
import { NgxChartsModule, id } from '@swimlane/ngx-charts';
import { Color, ScaleType } from '@swimlane/ngx-charts';
import { AnalisisCombinadoService } from '../../../services/operative/analisis-combinado/analisis-combinado.service';

import Swal from 'sweetalert2';
import moment from 'moment';
import { event } from '../../funciones/estructuras';
import ApexCharts from 'apexcharts';
import { companies } from '../../../shared/catalogos';


@Component({
  selector: 'app-analisis-combinado',
  templateUrl: './analisis-combinado.component.html',
  styleUrl: './analisis-combinado.component.css'
})
export class AnalisisCombinadoComponent {

  //---------------VARIABLES GENERALES
  private errorMessage = '<br/><br/><div> <span style="text-aling: center;font-size: 10pt;font-weight: 200;">Precione</span>'+
  '<span style="text-aling: center;font-size: 10pt;font-weight: 600;"> esc </span>'+
  '<span style="text-aling: center;font-size: 10pt;font-weight: 200;">para cerrar</span></div>';
  public colorMulti: any = ['#2843A0','#15A075','#36CAE8','#78EAD2','#F88476','#E23E6A'];
  public colorMono: any = ['#76C4D5'];
  //-------------VARIABLES OBTENCION DE PERIODOS
  private numEvaluaciones = 1;
  public Periodos = [];
  public Periodos2 = [];
  /*Titulos y subtitulos*/
  public subTitles = '';
  public subTitles2 = '';
  public subTitlesPat = '';
  /*Filtros*/
  public cadenaEvaluacion = [];
  public cadenaEvaluacion2 = [];
  public cadenaPatrimonio = [];
   
  //----------VARIABLES DEL TABLERO
  public perspectivasx = [];
  public perspectivasy = [];
  public encPersx = '';
  public encPersy = '';

  private catalogos = [
    {name: 'Acción realizada', cat: []},
    {name: 'Agencia/Sucursal', cat: []},
    {name: 'Control', cat: []},
    {name: 'Estatus plan', cat: []},
    {name: 'Fuente', cat: []},
    {name: 'Impacto', cat: []},
    {name: 'Perdida', cat: []},
    {name: 'Probabilidad', cat: []},
    {name: 'Riesgo derivado', cat: []},
    {name: 'Área', cat: []},
  ]

  private categoria = [];

    public reportes = [];
    private reportesAll = [];
    public valores = [];
    public numeroEve = [];
    public proporEve = [];
    public metrica = "num";
    public perdidax = false;
    public perdiday = false;
    public niveles = 3;
    public patrimonio = false;
    public periodosPat = [];
    public montoPatri = 0;

    
    public catalogosLLen = [];

    public titulosx = [];
    public titulosy = [];

    //grafica
    public options: any = {};
    public chart;
    public chart2;
    public renderGrafica = false;
    public chartAmp;
    public tituloModal = '';
    public tipoGraf = 'bar';
    public hori = true;

    public colorScheme: Color = {
      name: 'myScheme',
      selectable: true,
      group: ScaleType.Ordinal,
      domain: ['#2843A0','#15A075','#36CAE8','#78EAD2','#F88476','#E23E6A']
    };
    public datosGraf = [];
    public showXAxis = true;
    public showYAxis = true;
    public showLegend: boolean = false;
    public showLabels: boolean = false;
    public isDoughnut: boolean = true;
    public showDataLabel: boolean = false;
    public showXAxisLabel = true;
    public xAxisLabel = '';
    public showYAxisLabel = true;
    public yAxisLabel = '';
    public maxRadius: number = 30;
    public minRadius: number = 4;
    public yScaleMin: number = 70;
    public yScaleMax: number = 85;
    public xScaleMin: number = 70;
    public xScaleMax: number = 85;
    public view: any[] = [700, 400];

    public filtroPeriodos = false;
    private idInstitucion = '';

    public suffix = 'MXN';
    public miles = ',';
    public decimal = '.';

  constructor(
    public dataService: DataService,
    private translate: TranslateService,
    private cookieService: CookieService,
    private service: AnalisisCombinadoService,
    private exportExcel: ExcelService,
  ) {
    this.idInstitucion = this.cookieService.get('idInstitucion');
    const ex = companies.find(i => i.id === this.idInstitucion);
    this.suffix = ex.suffix;
    this.getPeriodoPat();
    this.startCatalogs();
  }
  private async startCatalogs(){
    const catalogos = [
      'accion',
      'agencia',
      'control',
      'estatusplan',
      'fuente',
      'impacto',
      'perdida',
      'probabilidad',
      'riesgo',
      'area',
      'categoria'
    ] as const;

    const data = await firstValueFrom(
      forkJoin(
        Object.fromEntries(
          catalogos.map(tipo => [
            tipo,
            this.service.getCatalogos(this.idInstitucion, tipo),
          ]),
        ),
      ),
    );
    this.catalogos[0].cat = [].concat(data['accion']);
    this.catalogos[1].cat = [].concat(data['agencia']);
    this.catalogos[2].cat = [].concat(data['control']);
    this.catalogos[3].cat = [].concat(data['estatusplan']);
    this.catalogos[4].cat = [].concat(data['fuente']);
    this.catalogos[5].cat = [].concat(data['impacto']);
    this.catalogos[6].cat = [].concat(data['perdida']);
    this.catalogos[7].cat = [].concat(data['probabilidad']);
    this.catalogos[8].cat = [].concat(data['riesgo']);
    this.catalogos[9].cat = [].concat(data['area']);
    this.categoria = [].concat(data['categoria']);
    this.getEvaluacion();
  }

  ngOnInit(): void {}

  /* Mensaje de error consultas */
  private errorMesage(err){
    var errores = ''
    for(const er of err.message){
      errores += er +'<br>'
    }
    var texto = errores + this.errorMessage;

    Swal.fire({
      html: texto,
      icon: 'error',
      showCancelButton: false,
      showConfirmButton: false,
    });
  }
  ///----------FUNCIONES OBTENCION DE PERIODOS 
  //obtencion de periodos
  private getEvaluacion(){

      this.obtCatalogos();
  }
  private ordenamientoDataEvaluacion() {
    const iniDate = this.reportesAll.map( i => moment(i.event_date) ).sort( (a, b) => a.diff(b))[0];
    
    const fecha = moment();
    this.Periodos = periodosOperativo.obtenerPeriodosFechas(fecha, iniDate);
    this.Periodos[this.Periodos.length-1].series[this.Periodos[this.Periodos.length-1].series.length-1].check = false;
    this.Periodos[0].series[0].check = true;
    this.Periodos2 = periodosOperativo.obtenerPeriodosFechas(fecha, iniDate);
    this.obtenerDataEvaluacion();
  }
  /* Obtención de periodos */
  private obtenerDataEvaluacion(){
    this.cadenaEvaluacion = [];
    this.cadenaEvaluacion2 = [];
    this.subTitles = "";
    this.subTitles2 = "";
    var tot=0;
    for(var i = this.Periodos.length-1; i>=0; i--){
      for(var j = this.Periodos[i].series.length-1; j>=0; j--){
        if(this.Periodos[i].series[j].check){
          this.cadenaEvaluacion.push({
            evaluacion: this.Periodos[i].series[j].periodo,
            porcentaje: '%',
            periodo: this.Periodos[i].series[j].an + '-' + FuncionesMes.f_switchmes3(this.Periodos[i].series[j].mes)
          });
          tot++;
        }
      }
    }
    for(var i = this.Periodos2.length-1; i>=0; i--){
      for(var j = this.Periodos2[i].series.length-1; j>=0; j--){
        if(this.Periodos2[i].series[j].check){
          this.cadenaEvaluacion2.push({
            evaluacion: this.Periodos2[i].series[j].periodo,
            porcentaje: '%',
            periodo: this.Periodos2[i].series[j].an + '-' + FuncionesMes.f_switchmes3(this.Periodos2[i].series[j].mes)
          });
          tot++;
        }
      }
    }
    this.subTitles = this.cadenaEvaluacion[0].evaluacion;
    this.subTitles2 = this.cadenaEvaluacion2[0].evaluacion;
    var check = false, contador = 0;
    for(let i = 0; i < this.Periodos.length; i++){
      for(let j = 0; j < this.Periodos[i].series.length; j++){
        if(this.Periodos[i].series[j].check || check){
          this.Periodos2[i].series[j].visible = true;
          check = true;
        }else{
          this.Periodos2[i].series[j].visible = false;
        }
        if(this.Periodos2[i].series[j].visible){
          contador++;
        }
      }
      if(contador == 0){
        this.Periodos2[i].visible = false;
      }
    }
    this.selecCategoriaFilter();
  }
  /* formateo de datos */
  public escrituraPeriodo(Periodo){
    if(Periodo.split(' ').length === 2){
      const datos = Periodo.split(' ');
      return this.translate.instant('filtros.'+datos[0])+' '+datos[1];
    }else if(Periodo.split(' ').length === 5){
      const datos = Periodo.split(' ');
      return this.translate.instant('filtros.'+datos[0])+' '+datos[1]+' '+datos[2]+' '+this.translate.instant('filtros.'+datos[0])+' '+datos[1];
    }
    return Periodo;
  }
  //Filtro Periodo
  ///funcion para select periodo
  public cambioPeriodo(per, rango){
    if(rango == 'inicio'){
      for(const an of this.Periodos){
        for(const mes of an.series){
          if(mes.periodo === per.periodo){
            mes.check = true;
          }else{
            mes.check = false;
          }
        }
      }
      var check = false, contador = 0, selec2 = 0, posAn = 0, posMes = 0;
      for(let i = 0; i < this.Periodos.length; i++){
        for(let j = 0; j < this.Periodos[i].series.length; j++){
          if(this.Periodos[i].series[j].check || check){
            this.Periodos2[i].series[j].visible = true;
            if(!check){
              posAn = i;
              posMes = j;
            }
            check = true;
          }else{
            this.Periodos2[i].series[j].visible = false;
            this.Periodos2[i].series[j].check = false;
          }
          if(this.Periodos2[i].series[j].visible){
            contador++;
          }
          if(this.Periodos2[i].series[j].check){
            selec2++;
          }
        }
        if(contador == 0){
          this.Periodos2[i].visible = false;
        }else{
          this.Periodos2[i].visible = true;
        }
      }
      if(selec2 === 0){
        this.Periodos2[posAn].series[posMes].check = true;
      }
    }
    if(rango == 'fin'){
      for(const an of this.Periodos2){
        for(const mes of an.series){
          if(mes.periodo === per.periodo){
            mes.check = true;
          }else{
            mes.check = false;
          }
        }
      }
    }
    
    this.obtenerDataEvaluacion();
  }
  //filtro perspectiva
  public cambioPerspectiva(i, pos, eje){
    if(eje == 'x'){
      for(let k = 0; k < this.perspectivasy.length; k++){
        if( k === pos ){
          this.perspectivasy[k].visible = false;
        }else{
          this.perspectivasy[k].visible = true;
        }

        if( (this.perspectivasx[pos].perspec === 'Perdida' || this.perspectivasx[pos].perspec === 'Pérdida patrimonial') && 
            (this.perspectivasy[k].perspec === 'Perdida' || this.perspectivasy[k].perspec === 'Pérdida patrimonial') ){
              this.perspectivasy[k].visible = false;
              this.metrica = "num";
        }
      }
      if(i === this.encPersy || (this.perspectivasx[pos].perspec === 'Perdida' || this.perspectivasx[pos].perspec === 'Pérdida patrimonial')){
        for(let j = 0; j < this.perspectivasy.length; j++){
          if(this.perspectivasy[j].visible){
            this.encPersy = this.perspectivasy[j].perspec;
            break;
          }
        }
      }
      this.encPersx = i;
    }else{
      this.encPersy = i;
    }

    if(this.encPersx === "Pérdida patrimonial" || this.encPersy === "Pérdida patrimonial"){
      this.patrimonio = true;
    }else{
      this.patrimonio = false;
    }

    this.obtenerDataNuevamente();
  }
  private obtenerDataNuevamente(){
    this.perdidax = false;
    this.perdiday = false;
    if(this.encPersx === 'Pérdida patrimonial' || this.encPersy === 'Pérdida patrimonial'){
      this.getTitulos();
      this.getDataPerdida();
      //this.grafPatrimonio("bar", true);
    }else{
      this.getTitulos();
      this.getData();
    }
    
    if(this.encPersx == "Perdida"){
      this.perdidax = true;
      this.getPerdida();
    }
    if(this.encPersy == "Perdida"){
      this.perdiday = true;
      this.getPerdida();
    } 
  }
  //-------FUNCIONES DEL TABLERO 
  public getPerspectivas(){
    let i = 0;
    for(const cat of this.catalogosLLen){
      this.perspectivasx.push({
        perspec: cat.nombre,
        visible: true,
      });
      this.perspectivasy.push({
        perspec: cat.nombre,
        visible: i===0?false:true,
      });
      i++;
    }

    this.encPersx = this.perspectivasx[0].perspec;
    this.encPersy = this.perspectivasy[1].perspec;
    this.getReportes();
  }
  private getReportes(){
    this.reportes = [];
    let aux = [];
    this.service.getEventos().subscribe(response =>{
      const event = response['data'];
      var i = 0;
      for(const rep of event){
        if(rep.institution_id === this.idInstitucion){
          aux.push({
            area : Number(rep.area),
            categorias : Number(rep.category),
            evento : Number(rep.event),
            fecha : moment(rep.event_date.split('T')[0]).format("YYYY-MM-DD"),
            accion : Number(rep.action_taken),
            riesgo : Number(rep.derived_risk),
            monto : Number(rep.loss_amount),
            impacto : Number(rep.impact),
            control : Number(rep.control),
            riesgoImp : Number(rep.implicit_risk),
            porACont : Number(rep.to_control),
            agencia : Number(rep.branch_office),
            concepto : Number(rep.concept),
            detalle : rep.detail,
            fuente : Number(rep.source),
            perdida : Number(rep.loss),
            perdidaTras : Number(rep.transferred_loss),
            probabilidad : Number(rep.probability),
            riesgoImp2 : Number(rep.implicit_risk_level),
            porControl : Number(rep.control_2),
            nivelExp : Number(rep.exposure_level),
            recomRies : rep.recommendation,
            plan : rep.work_plan,
            quienReg : Number(rep.register),
            estatusPlan : Number(rep.plan_status),
            perdida_neta : Number(rep.net_loss),
            x : Number(rep.x),
            y : Number(rep.y),
            estatusEvent: Number(rep.event_status),
            id : i,
            idReporte: rep.id,
            select: false
          });
          i++;
        }
        
      }
      this.reportes = [].concat(aux);
      this.reportesAll = [].concat(aux);
      this.getTitulos();
      this.getData();
      this.ordenamientoDataEvaluacion();
    }, error =>{
      this.errorMesage(error.error);
    });
  }
  private getData(){
    const arrego1 = this.catalogosLLen.filter(cat => cat.nombre === this.encPersy)[0].catalogo;
    const arrego2 = this.catalogosLLen.filter(cat => cat.nombre === this.encPersx)[0].catalogo;
    let auxFin = [], aux = [], tot = 0, totalesy = [], i = 0;
    let prop1 = this.encPersy.split(' ')[0].split('/')[0].toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    let prop2 = this.encPersx.split(' ')[0].split('/')[0].toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    for(const suc of arrego1){
      const data = this.reportes.filter( item => item[''+prop1] === suc.id);
      for(const ar of arrego2){
        const dat = data.filter( item => item[''+prop2] === ar.id);
        aux.push(dat.length);
        if(totalesy.length === arrego2.length){
          totalesy[i] += dat.length;
        }else{
          totalesy[i] = dat.length;
        }
        tot += dat.length;
        i++;
      }
      aux.push(tot)
      auxFin.push(aux);
      aux = [];
      tot=0;
      i=0;
    }
    let total = totalesy.reduce((a, b) => a + b, 0);
    totalesy.push(total);
    this.grafica2([].concat(auxFin),arrego1,arrego2);
    auxFin.push(totalesy);
    this.numeroEve = JSON.parse(JSON.stringify(auxFin));;
    this.proporEve = JSON.parse(JSON.stringify(auxFin));;
    this.valores = this.numeroEve;
    this.getProporciones();
  }
  public getProporciones(){
    for(let i = 0; i<this.proporEve.length; i++){
      for(let j = 0; j<this.proporEve[i].length; j++){
        if(this.proporEve[i].length-1 == j){ //col total
          var auxT = this.proporEve[i][j];
          this.proporEve[i][j] = auxT > 0 ? 100 : 0;
        }else{
          var aux = Number(((this.proporEve[i][j]/this.proporEve[i][this.proporEve[i].length-1])*100).toFixed(1));
          this.proporEve[i][j] = aux >= 0 ? aux : 0;
        }

      }
    }
  }
  public getPerdida(){
    let aux: any = [[],[]];
    if(this.encPersx === 'Perdida'){
      for(let i = 0; i < this.valores.length; i++){
        var b = this.valores[i][0];
        var c = this.valores[i][1];
        var d = this.valores[i][2];
        var cuan = (b+c)/(b+c+d);
        var noCuan = d/(b+c+d);
        this.valores[i][this.valores[i].length-1] = (b+c+d)>0 ? Number((cuan*100).toFixed(1)) : 0;
        this.valores[i].push((b+c+d)>0 ? Number((noCuan*100).toFixed(1)) : 0);
      }
    }else {
      for(let i = 0; i < this.valores[0].length; i++){
        var b = this.valores[0][i];
        var c = this.valores[1][i];
        var d = this.valores[2][i];
        var cuan = (b+c)/(b+c+d);
        var noCuan = d/(b+c+d);
        aux[0].push((b+c+d)>0 ? Number((cuan*100).toFixed(1)) : 0);
        aux[1].push((b+c+d)>0 ? Number((noCuan*100).toFixed(1)) : 0);
        
      }
      this.valores.pop();
      this.valores = this.valores.concat(aux);
    }
        
  }
  public getDataPerdida(){
    const arrego1 = this.catalogosLLen.filter(cat => cat.nombre === this.encPersy)[0].catalogo;
    const arrego2 = this.catalogosLLen.filter(cat => cat.nombre === this.encPersx)[0].catalogo;
    let auxFin = [], tot = 0, totalesy = [], i = 0;
    let prop1 = this.encPersy.split(' ')[0].split('/')[0].toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    let prop2 = this.encPersx.split(' ')[0].split('/')[0].toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    if(prop2 === 'perdida'){
      let aux = [];
      let contEven = 0, perCon = 0, perTrasCon = 0, perNetCon = 0;
      for(const suc of arrego1){
        this.perdidax = true;
        const data = this.reportes.filter( item => item[''+prop1] === suc.codigo);
        let per = 0, perTras = 0, perNet = 0;
        for(const d of data){
          per += d.monto;
          perTras += d.perdidaTras;
          perNet += d.perdida_neta;
        }
        contEven += data.length;
        perCon += per; 
        perTrasCon += perTras; 
        perNetCon += perNet;
        aux.push(data.length);
        aux.push(per);
        aux.push(Number(((per/this.montoPatri)*100).toFixed(1)));
        aux.push(perTras);
        aux.push(perNet);
        auxFin.push(aux);
        aux = [];
      }
      aux.push(contEven);
      aux.push(perCon);
      aux.push(Number(((perCon / this.montoPatri)*100).toFixed(1)));
      aux.push(perTrasCon);
      aux.push(perNetCon);
      auxFin.push(aux);
    }else{
      let aux = [[],[],[],[],[]];
      let contEven = 0, perCon = 0, perTrasCon = 0, perNetCon = 0;
      for(const suc of arrego2){
        this.perdiday = true;
        const data = this.reportes.filter( item => item[''+prop1] === suc.codigo);
        let per = 0, perTras = 0, perNet = 0;
        for(const d of data){
          per += d.monto;
          perTras += d.perdidaTras;
          perNet += d.perdida_neta;
        }
        contEven += data.length;
        perCon += per; 
        perTrasCon += perTras; 
        perNetCon += perNet;
        aux[0].push(data.length);
        aux[1].push(per);
        aux[2].push(Number(((per/this.montoPatri)*100).toFixed(1)));
        aux[3].push(perTras);
        aux[4].push(perNet);
      }
      aux[0].push(contEven);
      aux[1].push(perCon);
      aux[2].push(Number(((perCon / this.montoPatri)*100).toFixed(1)));
      aux[3].push(perTrasCon);
      aux[4].push(perNetCon);
      auxFin = aux;
    }

    this.numeroEve = JSON.parse(JSON.stringify(auxFin));;
    this.valores = this.numeroEve;
    this.grafPatrimonio(this.tipoGraf, this.hori);
    this.getProporciones();
  }
  public cambioMetrica(met){
    if(met == 'num'){
      this.valores = this.numeroEve;
    }else{
      this.valores = this.proporEve;
    }
    this.metrica = met;
  }
  public grafica2(datos, array1, array2){
    let aux = [];
    let data = [];
    this.xAxisLabel = this.encPersx;
    this.yAxisLabel = this.encPersy;

    for(var i=0; i<array1.length; i++){
      for(var j=0; j<array2.length; j++){
        if(datos[i][j] != 0){
          aux.push({
            name: '',
            x: array2[j].name,
            y: array1[i].name,
            r: datos[i][j] 
          });
        }
      }
      data.push({
        name: array1[i].name,
        series: aux 
      });
      aux = [];
    }
    this.datosGraf = data;
  }
  public getTitulos(){
    const datx = this.catalogosLLen.filter( cat => cat.nombre === this.encPersx);
    this.titulosx = this.llenarTitulos(datx[0].nombre, datx[0].catalogo);
    const daty = this.catalogosLLen.filter( cat => cat.nombre === this.encPersy);
    this.titulosy = this.llenarTitulos(daty[0].nombre, daty[0].catalogo);
  }
  public llenarTitulos(nombre, pers){
    let aux = [];
    for(let i of pers){
      aux.push({
        nombre: i.name
      });
    }
    if(nombre == "Perdida"){
      aux.push({
        nombre: "% Cuantificable"
      });
      aux.push({
        nombre: "% No cuantificable"
      });
    }
    return aux;
  }
  private obtCatalogos(){
    var i = 0, aux = [];
    for(const cat of this.catalogos){
      aux.push({
        nombre: cat.name,
        catalogo: cat.cat,
      });
    }
    this.catalogosLLen = aux;
    this.obtCategorias();
  }
  private obtCategorias(){
    var aux = [], auxCon = [], auxEven = [];
    for(const cat of this.categoria){
      if(cat.values.length !== 0){
        for(const con of cat.values){
          if(con.values.length!==0){
            for(const even of con.values){
              auxEven.push({
                name: even.name
              });
            }
          }
          auxCon.push({
            name: con.name,
            values: auxEven
          });
          auxEven = [];
        }
      }
      aux.push({
        name: cat.name,
        id: cat.id,
        values: auxCon,
      });
      auxCon = [];
    }

    let nombre = ' Categorías';
    this.catalogosLLen.push({
      nombre: nombre.substring(1),
      catalogo: aux,
    });

    this.catalogosLLen.sort(function (a, b) {
      if (a.nombre.normalize("NFD").replace(/[\u0300-\u036f]/g, "") > b.nombre.normalize("NFD").replace(/[\u0300-\u036f]/g, "")) {
        return 1;
      }
      if (a.nombre.normalize("NFD").replace(/[\u0300-\u036f]/g, "") < b.nombre.normalize("NFD").replace(/[\u0300-\u036f]/g, "")) {
        return -1;
      }
      return 0;
    });

    if(aux[0].values[0].values){
      this.niveles = 3;
    }else if(aux[0].values){
      this.niveles = 2;
    }
    this.getPerspectivas();
  }
  //ampliar la grafica 
  public ampliarGraf(){
    document.getElementById("ampliar")!.style.display = "block";
    setTimeout(() =>{  
      this.chart = new ApexCharts(
        document.querySelector("#graficaPatAmp"),//id del div 
        this.options
      );
      this.chart.render();
    }, 100);
  }
  //Cerrar modal ampliar grafica
  public closeModal(){
    document.getElementById("ampliar")!.style.display = "none";
  }
  //detecta el click fuera del modal y cierra 
  public clickFuera(event){
    if (event.target === document.getElementById("ampliar")) {
      this.closeModal();
    }
  }
  //exportar grafica en imagen 
  public exportarGrafica(id, nombre, pers){
    IMG.exportimagenes(id,this.translate.instant(nombre) + pers + " " + this.escrituraPeriodo(this.subTitles) + "-" + this.escrituraPeriodo(this.subTitles2));
  }
  /* Filtros */
  public activacionFiltros(){
    this.filtroPeriodos = !this.filtroPeriodos;
    this.selecCategoriaFilter();
  }
  public selecCategoriaFilter(){
    if(this.reportesAll.length !== 0){
      let aux = [];
    
      aux = [].concat(this.reportesAll);

      if(this.filtroPeriodos){
        let aux2 = [];
        const fechaIni = moment(this.cadenaEvaluacion[0].periodo+'-01');
        const fechaFin = moment(this.cadenaEvaluacion2[0].periodo+'-01');
        for(const dat of aux){
          if(periodosOperativo.validacionPeriodo(moment(dat.fecha),fechaIni,fechaFin)){
            aux2.push(dat);
          }
        }
        aux = [].concat(aux2);
      }

      this.reportes = [].concat(aux);
      this.obtenerDataNuevamente();
    }
  }
  public escritura(val){
    if(Number.isInteger(val)){
      return formatear.formatearMoneda(val, false, this.miles, this.decimal);
    }
    return val;
  }
  ////FUNCIONES PARA PATRIMONIO 
  private getPeriodoPat(){
    // this.querySubscription = this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
    //   query: getPeriodoPatrimonio,
    //   context: { headers: this.headers, },
    //   variables: { idPlantilla: 7 }
    // }).valueChanges.subscribe(({ data }) => {
    //   //this.ordenamientoDataEvaluacion([].concat(data.evaluaciones));
    //   const info = CommonVariables.obtenerPeriodos([].concat(data.evaluaciones), 1);
    //   this.periodosPat = info.periodos;
    //   ///para siempre mostrar enero  IMPORTANTE BORRAR PARA PRODUCCION 
    //   this.periodosPat[this.periodosPat.length-1].series[this.periodosPat[this.periodosPat.length-1].series.length-1].check = false;
    //   this.periodosPat[this.periodosPat.length-1].series[0].check = true;
    //   ///////////////
    //   this.obtenerDataPatrimonio();
    // }, err =>{
    //   this.errorMessageGraph(err);
    // });
  }
  private getPatrimonio(){
    // this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
    //   query: getPatrimonioMonto,
    //   context: {headers: this.headers},
    //   variables: {"idEvaluacion": this.cadenaPatrimonio[0].id, "idCuenta": "P3"}
    // }).valueChanges.subscribe(({data}) => {
    //   this.montoPatri = data.detalleEvaluacionCuenta.valor;
    //   this.getDataPerdida();
    // }, error => {
    //   this.errorMessageGraph(error);
    // });
    
  }
  public cambioPeriodoPatrimonio(perPat){
    for(const an of this.periodosPat){
      for(const mes of an.series){
        if(mes.periodo === perPat.periodo){
          mes.check = true;
        }else{
          mes.check = false;
        }
      }
    }
    this.obtenerDataPatrimonio();
  }
  private obtenerDataPatrimonio(){
    this.cadenaPatrimonio = [];
    this.subTitlesPat = "";
    var tot=0;
    for(var i = this.periodosPat.length-1; i>=0; i--){
      for(var j = this.periodosPat[i].series.length-1; j>=0; j--){
        if(this.periodosPat[i].series[j].check){
          this.cadenaPatrimonio.push({
            evaluacion: this.periodosPat[i].series[j].periodo,
            id: this.periodosPat[i].series[j].id,
            periodo: this.periodosPat[i].series[j].an + '-' + FuncionesMes.f_switchmes3(this.periodosPat[i].series[j].mes)
          });
          tot++;
        }
      }
    }
    
    this.subTitlesPat = this.cadenaPatrimonio[0].evaluacion;
    var check = false, contador = 0;
    for(let i = 0; i < this.periodosPat.length; i++){
      for(let j = 0; j < this.periodosPat[i].series.length; j++){
        if(this.periodosPat[i].series[j].check || check){
          this.periodosPat[i].series[j].visible = true;
          check = true;
        }else{
          this.periodosPat[i].series[j].visible = false;
        }
        if(this.periodosPat[i].series[j].visible){
          contador++;
        }
      }
      if(contador == 0){
        this.periodosPat[i].visible = false;
      }
    }
    this.getPatrimonio();
    //this.selecCategoriaFilter();

  }
  public grafPatrimonio(tipo, eje){
    this.tipoGraf = tipo;
    this.hori = eje;

    var data = [];
    var etiquetas = [];
    var cantidades = [];

    let cont = 0;
    if(this.perdidax){
      let cont = 0;
      for(const i of this.titulosy){
        cantidades.push(this.valores[cont][2]);
        etiquetas.push(i.nombre);
        cont++;
      }
    }
    if(this.perdiday){
      let cont = 0;
      for(const i of this.titulosx){
        cantidades.push(this.valores[2][cont]);
        etiquetas.push(i.nombre);
        cont++;
      }
    }

    data.push({
      name: '',
      data: cantidades
    })    

    this.options = {
      chart: {
        width: "100%",
        height: "100%",
        type: tipo,
        toolbar: {
          show: false
        },
        animations: {
          enabled: true,
          easing: 'easeinout',
          speed: 800,
          animateGradually: {
              enabled: false,
          },
          dynamicAnimation: {
              enabled: false,
          }
        },
        zoom: {
          enabled: false
        }
      },
      plotOptions:{
        bar:{
          horizontal: eje,
        }
      },
      colors: this.colorMono,
      fill:{
        opacity: 0.7
      },
      dataLabels: {
        enabled: false
      },
      series: data,
      xaxis: {
        categories: etiquetas,
        labels: {
          maxHeight: 80,
          trim: true
        },
        tooltip: {
          enabled: false,
        }
      },
      yaxis: {
        style: {
          fontSize: '12px',
          fontFamily: 'Roboto',
          fontWeight: 600,
        },
        labels: {
          formatter: (value) => { 
            if(!eje){
              var val = formatear.retornarformatolefty(Number(value.toFixed(2)));
            var dat = val.split(' ');
            return  formatear.retornarformatoval(dat[0],dat[1],dat[2], this.miles, this.decimal);
            }else{
              return value
            }
            
          },
        }
      },
      tooltip:{
        enabled: true,
        theme: "dark"
      },
      grid: {
        show: false
      },
      markers: {
        size: 6,
        hover: {
          size: 6
        },
        fillOpacity: 1
      },
      stroke:{
        show: true,
        curve: "smooth"
      },

    };

    if(this.renderGrafica){
      this.chart.destroy();
    }
    setTimeout(() =>{  
      this.chart = new ApexCharts(
        document.querySelector("#graficaPat"),//id del div 
        this.options
      );
      this.chart.render();
      this.renderGrafica = true;
      this.options.stroke["show"] = true;
    }, 100);
  }
  public exportarTabla(){
    var titulos = [], datos = [];

    titulos.push(this.encPersx);
    for(const t of this.titulosx){
      titulos.push(t.nombre);
    }
    if(this.perdiday){
      titulos.push("Total general");
    }else if(!this.perdidax){
      titulos.push("Total");
    }else{

    }
    if(this.perdiday){
      for(let i = 0; i < this.titulosy.length; i++){
        var aux = [];
        aux.push(this.titulosy[i].nombre);
        for(let j = 0; j < this.valores[i].length; j++){
          aux.push(this.valores[i][j]);
        }
        datos.push(aux);
      }
    }else{
      for(let i = 0; i <= this.titulosy.length; i++){
        var aux = [];
        if(i < this.titulosy.length){
          aux.push(this.titulosy[i].nombre);
        }else if(this.perdidax){
          aux.push("Total general")
        }else{
          aux.push("Total")
        }
        for(let j = 0; j < this.valores[i].length; j++){
          aux.push(this.valores[i][j]);
        }
        datos.push(aux);
      }
    }
    let periodo = this.filtroPeriodos ? " | " + this.escrituraPeriodo(this.subTitles) +"-"+ this.escrituraPeriodo(this.subTitles2) : "";
    let patrimonio = this.encPersx == "Pérdida patrimonial" || this.encPersy == "Pérdida patrimonial" ? " | " + this.translate.instant('operative.analisis.patrimonio') + " " + this.escrituraPeriodo(this.subTitlesPat) + " " + this.escritura(this.montoPatri) : ""
    let tituloHoja = this.translate.instant('operative.analisis.tituloTabla') + this.encPersx.toLowerCase() + " y " + this.encPersy.toLowerCase() + periodo + patrimonio;
    let perdida;
    if(this.perdidax){
      perdida = "px"+this.encPersx;
    }else if(this.perdiday){
      perdida = "py"+this.encPersy;
    }else{
      perdida = "";
    }

    if(perdida == "pxPerdida"){
      for(let i = 0; i<datos.length; i++){
        datos[i][4] = datos[i][4]/100;
        datos[i][5] = datos[i][5]/100;
      }
    }
    if(perdida == "pyPerdida"){
      for(let i = 1; i<datos[0].length; i++){
        datos[3][i] = datos[3][i]/100;
        datos[4][i] = datos[4][i]/100;
      }
    }
    if(perdida == "pxPérdida patrimonial"){
      for(let i = 0; i<datos.length; i++){
        datos[i][3] = datos[i][3]/100;
      }
    }
    if(perdida == "pyPérdida patrimonial"){
      for(let i = 1; i<datos[0].length; i++){
        datos[2][i] = datos[2][i]/100;
      }
    }
    if(this.metrica == "prop"){
      for(let i = 0; i<datos.length; i++){
        for(let j = 1; j<datos[i].length; j++){
          datos[i][j] = datos[i][j]/100;
        }
      }
    }
    this.exportExcel.excelOpAnalisisComb(tituloHoja, titulos, datos, tituloHoja,perdida, this.metrica);
  }
}
